import { Platform } from 'react-native'

export const width = 128
export const height = 136
export const imageSize = 64
export const gap = Platform.select({ default: 16, web: 32 }) // itemGap for navigation

export const itemsRow = Platform.select({
  default: 5,
  web: 6,
})
